<div class="wos-loader" [class.fixed]="isFixed">
  <div class="w-loader"></div>
</div>
